// extracted by mini-css-extract-plugin
export default {"Button":"ModalWarning_Button__IHkiB","Modal":"ModalWarning_Modal__xMHy-","Content":"ModalWarning_Content__UK8Mj"};